import React from 'react';
import { Hero } from '@antonpodolsky/design-system/regions/hero/hero';
import { Stack } from '@antonpodolsky/design-system/layout/stack/stack';
import { Divider } from '@antonpodolsky/design-system/layout/divider/divider';
import { Heading } from '@antonpodolsky/design-system/typography/heading/heading';
import { Text } from '@antonpodolsky/design-system/typography/text/text';
import { SeparatedList } from '@antonpodolsky/design-system/data-display/separated-list/separated-list';
import { Button } from '@antonpodolsky/design-system/controls/button/button';
import { cloudinaryImage } from '../../lib/cloudinary';
import { SiteNav } from '../site/site-nav';
import { AddonButtonsWithRatings } from '../addon/addon-buttons-with-ratings';

const BACKGROUND_IMAGE = cloudinaryImage('v1755965004/web-bg.jpg');

export const HomepageHero = () => (
  <Hero
    nav={<SiteNav />}
    backgroundImage={BACKGROUND_IMAGE}
    footer={
      <Stack gap="3xl" align="center">
        <SeparatedList variant="accented">
          <Text>No ads</Text>
          <Text>No tracking</Text>
        </SeparatedList>

        <Button variant="outline" href="#more" endIcon="arrow_right_alt">
          Learn more
        </Button>
      </Stack>
    }
  >
    <Stack gap="xl">
      <Heading as="h1" variant="display-lg" caps>
        EXIF and C2PA viewer
      </Heading>
      <Text as="p" variant="lead-lg">
        Effortless image metadata on any website
      </Text>
      <Divider />
      <AddonButtonsWithRatings />
    </Stack>
  </Hero>
);
